/**
 * Sam video: intro film config vs optional diary catalog.
 *
 * Intro (Hero right column) may muted-autoplay for PREVIEW_DURATION only.
 * Diary clips must never autoplay. Extra clips stay out of VIDEO_DIARIES until they exist.
 *
 * kind:
 *   random — idle / below-the-fold rotation
 *   fuel   — after a verified payment (thank-you)
 */

export const PREVIEW_DURATION = 4;

export const MEET_SAM_INTRO = {
  src: "/videos/meet-sam.mp4",
  poster: "/sam-portrait.png",
  title: "Meet Sam",
};

/** Fill as random / fuel clips land. Empty = hide the below-hook diary block. */
export const VIDEO_DIARIES = [];

let previewHolder = null;

export function acquirePreview(token) {
  if (previewHolder && previewHolder !== token) return false;
  previewHolder = token;
  return true;
}

export function releasePreview(token) {
  if (previewHolder === token) previewHolder = null;
}

export function prefersReducedMotion(matchMedia) {
  const mm = matchMedia || (typeof window !== "undefined" ? window.matchMedia : null);
  if (typeof mm !== "function") return false;
  return Boolean(mm("(prefers-reduced-motion: reduce)").matches);
}

export function hasRandomDiaries(catalog = VIDEO_DIARIES) {
  return Boolean(catalog?.some((c) => c.kind === "random"));
}

export function pickDiary(catalog, { trigger = "random", lastId, random = Math.random } = {}) {
  if (!catalog || catalog.length === 0) return null;
  const tagged = catalog.filter((c) => c.kind === trigger);
  const pool = tagged.length ? tagged : catalog.filter((c) => c.kind === "random");
  if (!pool.length) return null;
  const avoid = pool.length > 1 ? pool.filter((c) => c.id !== lastId) : pool;
  const i = Math.min(avoid.length - 1, Math.floor(random() * avoid.length));
  return avoid[i];
}
